import { makeAutoObservable, runInAction } from "mobx";
import agent from "../../../../../app/api/agent";
import { DeliverablesQCData } from "../DeliverablesReport";
import { metadataType } from "../../../../../app/api/types";
// import { cleanData } from "./types";

interface DynamicTableData {
  headers: string[];
  body: any[];
}

interface LocalMetaData {
  [key: number]: metadataType[];
}

export default class masteringStore {
    consolidateList: any[] = [];
    consolidatePDFinfo: any[] = [];
    DcpEncrypedOpenReportInfo: any[] = [];
    FFV1ReportInfo: any[] = [];
    deliveriableInfo: DeliverablesQCData[] = [];
    LtoReportInfo: any[] = []
    DmAndBaseGradeList: {
        localMetaData: any[],
        dynData: any,
        bitDepth: {
            imgSrc: string;
            label: string
        }[],
        frames: { total: number, actual: number }
    } = {
            localMetaData: [],
            dynData: {},
            bitDepth: [],
            frames: { total: 0, actual: 0 }
        };
    ReelAnalysisData: {
        localMetaData: any,
        dynData: any,
        summary: string,
        supervisorDetails: metadataType[]
    } = {
            localMetaData: {},
            dynData: {},
            summary: '',
            supervisorDetails: []
        }
    RestorationData: {
        localMetaData: any,
        dynDataImageResto: any,
        dynDataSupervisor: any,
        supervisorDetails: metadataType[],
        emptyTable:boolean
    } = {
            localMetaData: {},
            dynDataImageResto: {},
            dynDataSupervisor: {},
            supervisorDetails: [],
            emptyTable:false
        }
        
    ColorGradingData:{
        localMetaData:LocalMetaData,
        dynData:DynamicTableData,
        dynDataOne:DynamicTableData,
        summary:string
        filmScannedType: metadataType[]
    } = {
        localMetaData:{},
        dynData:{
        headers: [],
        body: [],
      },
       dynDataOne: {
        headers: [],
        body: [],
      },
      summary: '',
      filmScannedType: []
    }
    deliverableError:any[] = [];


    constructor() {
        makeAutoObservable(this);
    }
    conslidatedApiCall = async (id: string, subtaskId: string, deliveryId: string, colorGradingId: string, RestorationId: string) => {
        try {
            const response = await agent.NFAI.Consolidated(id, subtaskId, deliveryId, colorGradingId, RestorationId);
            runInAction(() => {
                this.consolidateList = response.data;
            });
        } catch (error) {
            console.log(error)
        }
    }

        MasteringFileUploadHandler = async (name: string, subtaskId: string, url: any) => {
        try {
            let response = null;
            
            switch (name) {
            case "Encrypted QC Report":
            case "Open QC Report": {
                const { data } = await agent.NFAIReport.MetadataUploadMastring(subtaskId, url);
                response = data;
                break;
            }
            case "DPX QC Report":
            case "DSM QC Report": {
                const { data } = response = await agent.NFAIReport.MetadataUploadMastring(subtaskId, url);
                response = data;
                break;
            }
            default:
                break;
            }
            
            return response;
        } catch (error) {
            console.log(error);
            throw error; // Re-throw or handle properly
        }
        }
}